/**
 * @fileoverview Landing page section showcasing the profit over time chart.
 * @module features/landing/components/ProfitChartSection
 */

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { LandingProfitChart } from './LandingProfitChart'

/**
 * Profit chart section for the landing page.
 * Displays the profit over time area chart with mock data.
 *
 * @component
 */
export function ProfitChartSection(): ReactElement {
  const { t } = useTranslation('features-landing')

  return (
    <section className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold mb-4 text-foreground">
            {t('profitChart.title')}
          </h2>
          <p className="text-lg font-light text-muted-foreground leading-relaxed">
            {t('profitChart.description')}
          </p>
        </div>

        {/* Profit Chart */}
        <LandingProfitChart className="w-full" />
      </div>
    </section>
  )
}
